import * as PIXI from "pixi.js";
import data from "./configs/data";
import {Button} from "./controlElements/Button";
import {PixiApplication} from "./PixiApplication";

export class Paytable extends PIXI.Container {

    public static getInstance(): Paytable {
        if (!Paytable.OBJ_INSTANCE) {
            Paytable.OBJ_INSTANCE = new Paytable();
        }
        return Paytable.OBJ_INSTANCE;
    }

    private static OBJ_INSTANCE: Paytable;

    private page1: PIXI.Sprite;
    private page2: PIXI.Sprite;
    private leftArrow: Button;
    private rightArrow: Button;
    private currentPageIndex: number = 0;

    private readonly PAGES_AMOUNT: number = 2;

    private readonly CLOSE_BUTTON_POSITION = new PIXI.Point(1127, 52);
    private readonly LEFT_ARROW_POSITION = new PIXI.Point(185, 325);
    private readonly RIGHT_ARROW_POSITION = new PIXI.Point(1095, 325);

    private readonly PAGE_1_POSITION = new PIXI.Point(640, 290);

    private readonly PAGE_2_POSITION = new PIXI.Point(640, 290);

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private constructor() {
        super();

        this.createAndAddBackgroundBlend();
        this.createAndAddPage1Content();
        this.createAndAddPage2();
        this.createAndAddLeftArrowButton();
        this.createAndAddRightArrowButton();
        this.createAndAddCloseButton();
        this.close();
    }

    public open(): void {
        this.visible = true;
    }

    public close(): void {
        this.visible = false;
    }

    public toggleVisibility(): void {
        if (this.visible) {
            this.close();
        } else {
            this.open();
        }
    }

    private closeCurrentPage(): void {
        switch (this.currentPageIndex) {
            case 0:
                this.page1.visible = false;
                break;
            case 1:
                this.page2.visible = false;
                break;
            default:
                throw new Error("Page you want to close does not exist");
        }
    }

    private openPage(pageIndex: number): void {
        this.currentPageIndex = pageIndex;
        switch (this.currentPageIndex) {
            case 0:
                this.page1.visible = true;
                break;
            case 1:
                this.page2.visible = true;
                break;
            default:
                throw new Error("Page you want to close does not exist");
        }
    }

    private createAndAddLeftArrowButton(): void {
        this.leftArrow = new Button(data.images.payTableArrowBase, data.images.payTableArrowHover,
            data.images.payTableArrowHover, data.images.payTableArrowInActive, data.audios.buttonClicked);
        this.leftArrow.position = this.LEFT_ARROW_POSITION;
        this.leftArrow.position = this.LEFT_ARROW_POSITION;
        this.leftArrow.subscribeOnClicked(() => {
            this.closeCurrentPage();
            if ((this.currentPageIndex - 1) < 0) {
                this.openPage(this.PAGES_AMOUNT - 1);
            } else {
                this.openPage(this.currentPageIndex - 1);
            }
        });
        this.addChild(this.leftArrow);
    }

    private createAndAddRightArrowButton(): void {
        this.rightArrow = new Button(data.images.payTableArrowBase, data.images.payTableArrowHover,
            data.images.payTableArrowHover, data.images.payTableArrowInActive, data.audios.buttonClicked);
        this.rightArrow.position = this.RIGHT_ARROW_POSITION;
        this.rightArrow.scale.x = -1;
        this.rightArrow.subscribeOnClicked(() => {
            this.closeCurrentPage();
            this.openPage((this.currentPageIndex + 1) % this.PAGES_AMOUNT);
        });
        this.addChild(this.rightArrow);
    }

    private createAndAddPage1Content(): void {
        this.page1 = PIXI.Sprite.fromImage(data.images.howToPlay1);
        this.page1.interactive = true;
        this.page1.position = this.PAGE_1_POSITION;
        this.page1.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.page1);
    }

    private createAndAddPage2(): void {
        this.page2 = PIXI.Sprite.fromImage(data.images.howToPlay2);
        this.page2.interactive = true;
        this.page2.position = this.PAGE_2_POSITION;
        this.page2.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(this.page2);
        this.page2.visible = false;
    }

    private createAndAddCloseButton(): void {
        const contentClose = new Button(data.images.payTableCloseBase, data.images.payTableCloseHover,
            data.images.payTableCloseClick, data.images.payTableCloseClick, data.audios.buttonClicked);
        contentClose.position = this.CLOSE_BUTTON_POSITION;
        contentClose.subscribeOnClicked(() => {
            this.close();
        });
        this.addChild(contentClose);
    }

    private createAndAddBackgroundBlend(): void {
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0x000000, 0.3);
        graphics.drawRect(-PixiApplication.WIDTH / 2, -PixiApplication.HEIGHT / 2,
            PixiApplication.WIDTH, PixiApplication.HEIGHT);
        graphics.endFill();
        const backgroundBlend = new PIXI.Sprite(graphics.generateCanvasTexture());
        backgroundBlend.position.x = PixiApplication.WIDTH / 2;
        backgroundBlend.position.y = PixiApplication.HEIGHT / 2;
        backgroundBlend.anchor = this.DEFAULT_ANCHOR_POINT;
        backgroundBlend.interactive = true;
        this.addChild(backgroundBlend);
    }
}



// WEBPACK FOOTER //
// ./src/app/Paytable.ts